import React, {useRef, useState, useEffect} from "react";
import Select, {defaultTheme, components} from 'react-select';
import AsyncSelect from 'react-select/async';
import { authenticatedApi } from "api";
// import makeAnimated from 'react-select/animated';
// import './MaestroSelect.scss';
import MaestroSelect from "./MaestroSelect";
import { Box, Grid } from "@mui/joy";


/*
<span ng-if="searchGroup.possibleOptions[search.type].type == 'select' && searchSelects[search.type]">
    <mm-search-select model="search.value" display="{{searchSelects[search.type].display}}" sub-display="{{searchSelects[search.type].sub_display}}" search="{{searchSelects[search.type].search}}" bind="id" search-hydrate="[search.value]" mm-change="cacheSelectedObject"></mm-search-select>
</span>
*/

let involvementDates = {};
let cached = {};

let objectTypes = {
    contact: {
        endpoint: 'contacts',
        include: [],
        display: 'name',
    },
    workplan: {
        endpoint: 'work-plans',
        include: [],
        display: 'name',
    },
    business: {
        endpoint: 'businesses',
        include: [],
        display: 'name',
    },
    property: {
        endpoint: 'properties',
        include: ['address'],
        display: 'address',
    },
    event: {
        endpoint: 'events',
        include: [],
        display: 'name',
    },
    /*
    donation: {
        endpoint: 'contacts',
        include: [],
        display: 'name',
    },
    */
    opportunity: {
        endpoint: 'volunteer-opportunities',
        include: [],
        display: 'name',
    },
    business_type: {
        endpoint: 'business-type',
        simple: true,
        include: ['name'],
        display: (obj) => `${obj.name}`,
    },
    membership_level: {
        endpoint: 'membership-levels',
        simple: true,
        include: ['name'],
        display: 'name',
    },
    land_use: {
        endpoint: 'land-use',
        simple: true,
        include: ['name'],
        display: (obj) => `${obj.name}`,
    },
    tif: {
        endpoint: 'tifs',
        simple: true,
        include: ['name'],
        display: 'name',
    },
    ssa: {
        endpoint: 'ssas',
        simple: true,
        include: ['name'],
        display: 'name',
    },
    zone: {
        endpoint: 'zones',
        simple: true,
        include: [],
        display: 'name',
    },
    registry: {
        endpoint: 'registries',
        simple: true,
        include: [],
        display: 'name',
    },
    involvement: {
        endpoint: 'involvements',
        simple: true,
        include: ['default'],
        display: 'name',
    },
    appeal: {
        endpoint: 'appeals',
        simple: true,
        include: [],
        display: 'name',
    },
    fund: {
        endpoint: 'funds',
        simple: true,
        include: [],
        display: 'name',
    },
    campaign: {
        endpoint: 'campaigns',
        simple: true,
        include: [],
        display: 'name',
    },

    // these are for options that are provided manually
    preferred_contact_method: {},
    frequency: {},
    donation_type: {},
};

// alternate spellings
objectTypes.contacts = objectTypes.contact;
objectTypes.workplans = objectTypes.workplan;
objectTypes['work-plan'] = objectTypes.workplan;
objectTypes['work-plans'] = objectTypes.workplan;
objectTypes.businesses = objectTypes.business;
objectTypes.properties = objectTypes.property;
objectTypes.events = objectTypes.event;
/*
objectTypes.donations = objectTypes.donation;
objectTypes.importers = objectTypes.importer;
*/
objectTypes.opportunities = objectTypes.opportunity;

objectTypes.event_chair = objectTypes.contact;
objectTypes.donor_contact = objectTypes.contact;

objectTypes.donor_business = objectTypes.business;

objectTypes.former_contact = objectTypes.contact;
objectTypes.former_business = objectTypes.business;

let getRealObjectName = (objectName) => {
    return objectName.replace(/.*related_to_/, '')
        .replace('_owner', '')
        .replace('_donor', '')
        // .replace('sign_up_related_to_contact')
    ;
};

const MaestroSearchSelect = (props) => {
    // const [isLoaded, setIsLoaded] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [loadedOptions, setLoadedOptions] = useState([]);

    let objectName = props.object ? getRealObjectName(props.object) : '';

    useEffect(() => {
        if(/*isLoaded || */!props.object || !objectTypes.hasOwnProperty(objectName)) {
            return;
        }

        // TODO: handle case where we change subdomain(s)
        if(cached.hasOwnProperty(objectName)) {
            setLoadedOptions(cached[objectName]);
            return;
        }

        if(isLoading) return;

        if(props.searchOption.hasOwnProperty('providedOptions')) {

            let providedOptions = props.searchOption.providedOptions;
            // map vals to same key/val
            if(typeof providedOptions[0] === 'string') {
                providedOptions = providedOptions.map((label) => ({value: label, label}));
                //[{value: 'home', label: 'Home'},
            }

            cached[objectName] = providedOptions;
            setLoadedOptions(providedOptions);
            return;
        }

        setIsLoading(true);

        const objectType = objectTypes[objectName];

        const communitiesToSerach = props.selectedCommunities.map(c => c.value).join(',');

        // console.log(communitiesToSerach);

        // `${objectType.endpoint}?communities=${communitiesToSerach}`

        authenticatedApi.get(`${objectType.endpoint}?per_page=-1&include=${objectType.include ? objectType.include.join(',') : 'none'}&communities=${communitiesToSerach}`).then(response => {
            let results = [];

            response.data.data.map((item, index) => {
                results.push({
                    label: typeof objectType.display === 'function' ? objectType.display(item) : item[objectType.display], // todo: handle sub-display
                    value: item.id,
                });

                if(objectType.endpoint === 'involvements' && item.involvement_dates && !involvementDates.hasOwnProperty(item.id)) {
                    involvementDates[item.id] = [];
                    item.involvement_dates.map((involvementDate, ind) => {
                        involvementDates[item.id].push({
                            label: involvementDate.date,
                            value: involvementDate.date,
                        });
                    });
                }
            });

            // todo: swap to order=asc&orderby= item[objectType.display]
            results.sort((a, b) => {
                return a.label.localeCompare(b.label);
            });

            cached[objectName] = results;

            setLoadedOptions(results);



        }).catch((e) => {
            console.log(e);
        }).finally(() => {
            setIsLoading(false);
        });
    }, [objectName]);

    useEffect(() => {
        // check if our value is a simple ID and if so update it to match
        setTimeout(() => {
            //
            if(typeof props.value === 'number') {
                // console.log(props.value);
                // console.log(loadedOptions);
                for(const result of loadedOptions) {
                    if(parseInt(props.value) == parseInt(result.value)) {
                        props.onChange(result);
                        break;
                    }
                }
            }
            else if(typeof props.value === 'string') { // involvments are stored as strings
                for(const result of loadedOptions) {
                    if(props.value == result.value) {
                        props.onChange(result);
                        break;
                    }
                }
            }

            if(typeof props.value2 !== 'undefined') { // involvments are stored as strings
                try {
                    let parentVal = typeof props.value === 'number' ? props.value : props.value.value;
                    for(const involvementDate of involvementDates[parentVal]) {
                        if(props.value2 == involvementDate.value) {
                            props.onChange2(involvementDate);
                            break;
                        }
                    }
                } catch(e){}
            }
        }, 50);
    }, [loadedOptions]);

    if(!objectName) {
        return <em>Object type must be specified</em>
    }

    if(!objectTypes.hasOwnProperty(objectName)) {
        return <em>Object is not configured</em>
    }

    return (<Grid columns={2} spacing={2} direction={'row'}>
        <MaestroSelect
            isLoading={isLoading}
            isDisabled={isLoading}
            options={loadedOptions}
            value={props.value}
            onChange={props.onChange}

            // component={AsyncSelect}
            // isLoading={isLoading}
            // cacheOptions={true}
            // loadOptions={loadOptions}
        />
        {objectTypes[objectName].endpoint === 'involvements' && props.value && props.selectedCommunities.length === 1 && (
            <Box sx={{mt: '0.5rem'}}>
            <MaestroSelect
                isLoading={isLoading}
                isDisabled={isLoading}
                options={involvementDates[props.value.value]}
                value={props.value2}
                onChange={props.onChange2}
                isClearable={true}

                // component={AsyncSelect}
                // isLoading={isLoading}
                // cacheOptions={true}
                // loadOptions={loadOptions}
            />
            </Box>
        )}
        </Grid>);

}

export default MaestroSearchSelect;
